import { z } from 'zod'

/**
 * The plans screen's URL search params.
 *
 * The selected group is the screen's filter — which customer's entitlements
 * are on show — so it lives in the URL: a specific group's view is linkable
 * and survives a reload (AGENTS.md).
 */
export const plansSearchSchema = z.object({
  group: z.string().optional(),
})

export type PlansSearch = z.infer<typeof plansSearchSchema>
